import { useEffect, useState } from 'react';

export function useAppVersion() {
  const [currentVersion, setCurrentVersion] = useState<string>('');
  const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);

  useEffect(() => {
    // Get current version from meta tag
    const versionMeta = document.querySelector('meta[name="version"]');
    const currentVersion = versionMeta?.getAttribute('content') || '1.0.0';
    setCurrentVersion(currentVersion);

    // Check for updates every 5 minutes
    const checkForUpdates = () => {
      // Force reload if version has changed
      const newVersionMeta = document.querySelector('meta[name="version"]');
      const newVersion = newVersionMeta?.getAttribute('content') || '1.0.0';

      if (newVersion !== currentVersion) {
        setIsUpdateAvailable(true);
        // Force reload after 2 seconds
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    };

    const interval = setInterval(checkForUpdates, 5 * 60 * 1000); // 5 minutes

    // Also check on focus (when user returns to tab)
    const handleFocus = () => {
      checkForUpdates();
    };

    window.addEventListener('focus', handleFocus);

    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', handleFocus);
    };
  }, [currentVersion]);

  const forceRefresh = () => {
    // Clear all caches
    if ('caches' in window) {
      caches.keys().then(cacheNames => {
        cacheNames.forEach(cacheName => {
          caches.delete(cacheName);
        });
      });
    }

    // Clear service worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => {
          registration.unregister();
        });
      });
    }

    // Force reload
    window.location.reload();
  };

  return {
    currentVersion,
    isUpdateAvailable,
    forceRefresh,
  };
}
